import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Switch16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M10.9696 6.53032L12.0303 5.46966L7.99994 1.43933L3.96961 5.46966L5.03027 6.53032L7.99994 3.56065L10.9696 6.53032Z'
      fill='currentColor'
    />
    <path
      d='M5.03014 9.46959L3.96948 10.5303L7.99981 14.5606L12.0301 10.5303L10.9695 9.46959L7.99981 12.4393L5.03014 9.46959Z'
      fill='currentColor'
    />
  </Svg>
);

Switch16.displayName = 'Switch16';
export default Switch16;
